import { uploadStagedFile } from './stagedUpload';

/** FileInput uploads immediately; this still uploads File blobs in nested payloads. */

function isFileLike(v) {
  if (v == null || typeof v !== 'object') return false;
  if (typeof File !== 'undefined' && v instanceof File) return true;
  return typeof Blob !== 'undefined' && v instanceof Blob && typeof v.name === 'string';
}

export async function buildFormSubmitPayload(values) {
  async function walk(v) {
    if (isFileLike(v)) {
      return uploadStagedFile(v);
    }
    if (Array.isArray(v)) {
      return Promise.all(v.map((item) => walk(item)));
    }
    if (v !== null && typeof v === 'object' && Object.getPrototypeOf(v) === Object.prototype) {
      const out = {};
      for (const k of Object.keys(v)) {
        out[k] = await walk(v[k]);
      }
      return out;
    }
    return v;
  }

  return walk(values);
}
